<div class="patient">
  <div class="wrapper">
    <app-page-header>
      <div class="l-header-panel">
        <div class="header">
          <h1 class="t-title-main">{{'GUI.dashboard.labels.dashboard' | translate}}</h1>
        </div>
      </div>
    </app-page-header>

    <main class="l-deashboard">
      <section class="dash" [class.dash--editing]="editMode()" [attr.dir]="dir()">
        <!-- ======= Title Bar (Start) ======= -->
        <header class="dash__head">
          <div>
            <div class="dash__greeting">{{ greeting() }}</div>
            <div class="dash__title">
              {{ userName }} <span>{{ userNameLast }}</span>
              @if (isAdmin) {
              <span class="dash__admin-badge">
                {{'GUI.dashboard.labels.chips.admin' | translate}}
              </span>
              }
            </div>
            <div class="dash__subtitle">
              {{ today() }} · {{'GUI.dashboard.labels.practice at a glance' | translate}}
            </div>
          </div>
          <div class="dash__actions">
            @if (editMode()) {
            <span class="dash__edit-hint">
              <mat-icon>open_with</mat-icon>
              {{'GUI.dashboard.labels.drag to rearrange' | translate}}
            </span>
            <button type="button" class="dash__edit-btn" (click)="resetLayout()">
              <mat-icon>restart_alt</mat-icon>
              {{'GUI.dashboard.labels.reset layout' | translate}}
            </button>
            <button type="button" class="dash__edit-btn" (click)="cancelCustomize()">
              {{'GUI.dashboard.labels.cancel customize' | translate}}
            </button>
            <button
              type="button"
              class="dash__edit-btn dash__edit-btn--primary"
              [disabled]="savingLayout()"
              (click)="saveLayout()"
            >
              <mat-icon>check</mat-icon>
              {{'GUI.dashboard.labels.save layout' | translate}}
            </button>
            @if (layoutSaveError()) {
            <span class="dash__edit-error" role="alert">
              <mat-icon>error_outline</mat-icon>
              {{'GUI.dashboard.labels.layout save failed' | translate}}
            </span>
            } } @else { @if (canCustomize()) {
            <button type="button" class="dash__skip-toggle" (click)="startCustomize()">
              <mat-icon>dashboard_customize</mat-icon>
              {{'GUI.dashboard.labels.customize' | translate}}
            </button>
            }
            <button
              type="button"
              class="dash__skip-toggle"
              [class.on]="skipOnLogin()"
              (click)="toggleSkip()"
            >
              <mat-icon
                >{{ skipOnLogin() ? 'check' : (dir() === 'rtl' ? 'chevron_left' : 'chevron_right')
                }}</mat-icon
              >
              {{ skipOnLogin() ? ('GUI.dashboard.labels.skipping to tl' | translate) :
              ('GUI.dashboard.labels.skip to tl' | translate) }}
            </button>
            }
          </div>
        </header>
        <!-- ======= Title Bar (End) ======= -->

        <!-- ======= Widget Grid (Start) ======= -->
        @if (!layoutReady()) {
        <!-- Placeholder until the saved layout arrives, so the grid never flashes the default. -->
        <div class="dash-grid-skeleton" aria-hidden="true">
          <div class="skel dash-grid-skeleton__lg"></div>
          <div class="skel dash-grid-skeleton__sm"></div>
          <div class="skel dash-grid-skeleton__row"></div>
          <div class="skel dash-grid-skeleton__row"></div>
        </div>
        } @else {
        <div class="dash-grid-wrap" [style.height.px]="gridHeight()">
          <gridster [options]="gridOptions">
            @for (widget of layout(); track widget.id) {
            <gridster-item [item]="widget">
              @switch (widget.id) {

              <!-- ======= KPI — Subscription (Start) ======= -->
              <!-- @case ('kpi-subscription') {
              <app-dashboard-kpi-card
                [card]="kpiSubscription()"
                [loading]="kpiSubscription().loading ?? false"
              ></app-dashboard-kpi-card>
              } -->
              <!-- ======= KPI — Subscription (End) ======= -->

              <!-- ======= KPI — Patient Billing (Start) ======= -->
              @case ('kpi-patient-billing') {
              <app-dashboard-kpi-card
                [card]="kpiPatientBilling()"
                [loading]="kpiPatientBilling().loading ?? false"
                [billingPeriod]="billingPeriod()"
                (billingPeriodChange)="onBillingPeriodChange($event)"
              ></app-dashboard-kpi-card>
              }
              <!-- ======= KPI — Patient Billing (End) ======= -->

              <!-- ======= KPI — Storage (Start) ======= -->
              @case ('kpi-storage') {
              <app-dashboard-kpi-card
                [card]="kpiStorage()"
                [loading]="kpiStorage().loading ?? false"
                [storagePeriod]="storagePeriod()"
                (storagePeriodChange)="onStoragePeriodChange($event)"
              ></app-dashboard-kpi-card>
              }
              <!-- ======= KPI — Storage (End) ======= -->

              <!-- ======= Birthdays Banner (Start) ======= -->
              @case ('birthdays') {
              <app-scroll-banner
                icon="cake"
                heading="{{'GUI.dashboard.labels.birthdays this week' | translate}}"
                iconBg="var(--teal-bg)"
                iconColor="var(--teal-dark)"
                scope="clinic"
              >
                @if (loading()) { @for (_ of [1,2,3]; track $index) {
                <div class="bday-kpi-item">
                  <div class="skel skel--circle" style="width: 24px; height: 24px"></div>
                  <div class="skel" style="width: 100px; height: 14px"></div>
                  <div class="skel" style="width: 50px; height: 14px"></div>
                  <div class="skel" style="width: 44px; height: 26px; border-radius: 20px"></div>
                </div>
                } } @else { @for (b of birthdays(); track b.pid) {
                <div class="bday-kpi-item">
                  <!-- <mat-icon class="bday-icon">celebration</mat-icon> // hide icon for now too many items -->

                  <div class="bday-name">{{ b.name }}</div>
                  <div class="bday-date">{{ b.date }}</div>
                  @if (b.phone) {
                  <button
                    type="button"
                    class="bday-action bday-action--phone"
                    #phoneTip="matTooltip"
                    [matTooltip]="copiedPhone() === b.phone ? ('GUI.dashboard.labels.copied' | translate) : b.phone"
                    (click)="copyPhone(b.phone, phoneTip)"
                    (keyup.enter)="copyPhone(b.phone, phoneTip)"
                  >
                    <mat-icon>call</mat-icon>
                  </button>
                  } @if (b.email) {
                  <a
                    class="bday-action bday-action--email"
                    [matTooltip]="b.email"
                    [href]="'mailto:' + b.email"
                  >
                    <mat-icon>mail</mat-icon>
                  </a>
                  }
                  <button
                    type="button"
                    class="bday-action bday-action--view"
                    [matTooltip]="'GUI.dashboard.labels.view' | translate"
                    (click)="openBirthdayPatient(b.pid)"
                    (keyup.enter)="openBirthdayPatient(b.pid)"
                  >
                    <mat-icon>folder_shared</mat-icon>
                  </button>
                </div>
                } @empty {
                <span class="banner-empty">
                  {{'GUI.dashboard.labels.no birthdays this week' | translate}}
                </span>
                } }
              </app-scroll-banner>
              }
              <!-- ======= Birthdays Banner (End) ======= -->

              <!-- ======= Upcoming Births (Start) ======= -->
              @case ('upcoming-births') {
              <app-scroll-banner
                icon="child_care"
                heading="{{'GUI.dashboard.labels.upcoming births' | translate}}"
                iconBg="var(--teal-bg)"
                iconColor="var(--teal-dark)"
                scope="clinic"
              >
                @if (loading() || loadingUpcomingBirths()) { @for (_ of [1,2,3]; track $index) {
                <div class="upcoming-birth-item">
                  <div class="skel" style="width: 120px; height: 14px"></div>
                  <div class="skel" style="width: 80px; height: 12px"></div>
                  <div class="skel" style="width: 50px; height: 22px; border-radius: 20px"></div>
                </div>
                } } @else { @for (b of upcomingBirths(); track $index) {
                <div
                  class="upcoming-birth-item"
                  [class.upcoming-birth-item--overdue]="b.daysLeft < 0"
                  [class.upcoming-birth-item--today]="b.daysLeft === 0"
                >
                  <div class="upcoming-birth-item__name">{{ b.name }}</div>
                  <div class="upcoming-birth-item__edd">EDD {{ b.edd }}</div>
                  <span class="upcoming-birth-item__badge">{{ b.label }}</span>
                  @if (b.phone) {
                  <button
                    type="button"
                    class="bday-action bday-action--phone"
                    #phoneTip="matTooltip"
                    [matTooltip]="copiedPhone() === b.phone ? ('GUI.dashboard.labels.copied' | translate) : b.phone"
                    (click)="copyPhone(b.phone, phoneTip)"
                    (keyup.enter)="copyPhone(b.phone, phoneTip)"
                  >
                    <mat-icon>call</mat-icon>
                  </button>
                  } @if (b.email) {
                  <a
                    class="bday-action bday-action--email"
                    [matTooltip]="b.email"
                    [href]="'mailto:' + b.email"
                  >
                    <mat-icon>mail</mat-icon>
                  </a>
                  }
                  <button
                    type="button"
                    class="bday-action bday-action--view"
                    [matTooltip]="'GUI.dashboard.labels.view' | translate"
                    (click)="openBirthdayPatient(b.pid)"
                    (keyup.enter)="openBirthdayPatient(b.pid)"
                  >
                    <mat-icon>folder_shared</mat-icon>
                  </button>
                </div>
                } @empty {
                <span class="banner-empty">
                  {{'GUI.dashboard.labels.no upcoming births' | translate}}
                </span>
                } }
              </app-scroll-banner>
              }
              <!-- ======= Upcoming Births (End) ======= -->

              <!-- ======= Weekly Exam Breakdown (Start) ======= -->
              @case ('exam-breakdown') {
              <app-dashboard-exam-breakdown
                [loading]="loading()"
                [separatedMode]="separatedMode"
              ></app-dashboard-exam-breakdown>
              }
              <!-- ======= Weekly Exam Breakdown (End) ======= -->

              <!-- ======= Patient Links Sent (Start) ======= -->
              @case ('patient-links') {
              <app-dashboard-patient-links [loading]="loading()"></app-dashboard-patient-links>
              }
              <!-- ======= Patient Links Sent (End) ======= -->

              <!-- ======= Patient Invoices (Start) ======= -->
              @case ('patient-invoices') {
              <app-dashboard-patient-invoices
                [invoices]="patientInvoices()"
                [isEnabled]="billingEnabled()"
                [billingPeriod]="billingPeriod()"
                [loading]="loadingInvoices() || loadingBilling()"
                (periodChange)="onBillingPeriodChange($event)"
                (toggleAccess)="toggleBilling($event)"
                (invoiceClicked)="openInvoice($event)"
              ></app-dashboard-patient-invoices>
              }
              <!-- ======= Patient Invoices (End) ======= -->

              <!-- ======= Upcoming Appointments (Start) ======= -->
              @case ('upcoming-appointments') {
              <app-dashboard-upcoming-appointments
                [isEnabled]="apptEnabled()"
                [loading]="loading()"
                (toggleAccess)="toggleAppt($event)"
              ></app-dashboard-upcoming-appointments>
              }
              <!-- ======= Upcoming Appointments (End) ======= -->

              <!-- ======= Subscription (Start) ======= -->
              @case ('subscription') {
              <app-dashboard-subscription
                [isAdmin]="isAdmin"
                [canRequest]="canRequestFeatures"
                [subPayments]="subPayments()"
                [loadingSubPayment]="loadingSubPayment()"
                [hasMorningAccess]="hasMorningAccess()"
              ></app-dashboard-subscription>
              }
              <!-- ======= Subscription (End) ======= -->

              }
            </gridster-item>
            }
          </gridster>
        </div>
        }
        <!-- ======= Widget Grid (End) ======= -->
      </section>

      <app-embed-modal
        [url]="invoiceModalUrl()"
        title="Invoice"
        (closed)="closeInvoiceModal()"
      ></app-embed-modal>
    </main>
    <app-bottombar></app-bottombar>
  </div>
</div>
